import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Record as ImmutableRecord, List as ImmutableList } from 'immutable';
import { ALERT_SHOW, ALERT_DISMISS, ALERT_CLEAR } from '../actions/alerts';
const AlertRecord = ImmutableRecord({
  key: 0,
  title: '',
  message: '',
  severity: 'info',
  actionLabel: '',
  actionLink: '',
  action: () => {},
  dismissAfter: 6000
});
/** Get next key based on last alert. */
const getNextKey = state => {
  const last = state.last();
  return last ? last.key + 1 : 0;
};

/** Import the alert. */
const importAlert = (state, alert) => {
  const key = getNextKey(state);
  const record = AlertRecord(_objectSpread(_objectSpread({}, alert), {}, {
    key
  }));
  return state.push(record);
};

/** Delete an alert by its key. */
const deleteAlert = (state, alert) => {
  return state.filterNot(item => item.key === alert.key);
};
export default function alerts(state = ImmutableList(), action) {
  switch (action.type) {
    case ALERT_SHOW:
      return importAlert(state, action);
    case ALERT_DISMISS:
      return deleteAlert(state, action.alert);
    case ALERT_CLEAR:
      return state.clear();
    default:
      return state;
  }
}